

import { BidiModule } from '@angular/cdk/bidi';
import { PlatformModule } from '@angular/cdk/platform';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MwcAffixComponent } from './affix.component';

@NgModule({
  declarations: [MwcAffixComponent],
  exports: [MwcAffixComponent],
  imports: [BidiModule, CommonModule, PlatformModule]
})
export class MwcAffixModule {}
